<template>
  <div class="product-item-sizes">
    <div class="row align-items-center">
      <div class="col-2" />
      <div class="size-group col-8">
        <span
          v-for="(
            productSize, index
          ) of orderItemProduct.product_sizes"
          :key="index"
        >{{ productSize.name }}</span>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-2 text-end">
        <label>Qtys:</label>
      </div>
      <div class="size-group col-8">
        <div
          v-for="(
            productSize, index
          ) of orderItemProduct.product_sizes"
          :key="index"
          class="input-group mb-2 quantity-input"
        >
          <div
            v-if="!isOrderButton && !onlyQuantityInput"
            :id="`${index}-${orderItemProduct.id}-increase`"
            class="input-group-append"
            style="display: none"
          >
            <button
              class="btn btn-outline-secondary increase-btn"
              type="button"
              @click="incrementQuantity(productSize)"
            >
              +
            </button>
          </div>
          <input
                :id="`${index}-${orderItemProduct.id}`"
                v-model="productSize.user_given_quantity"
                class="form-control input-padding"
                :style="productQuantityValidate(productSize)"
                type="number"
                @focus="highlight(`${index}-${orderItemProduct.id}`)"
                @input="handleInputQuantity($event, orderItemProduct, productSize)"
                @blur="commitMoqQuantity(orderItemProduct, productSize)"
                @keyup.enter="commitMoqQuantity(orderItemProduct, productSize)"
                :disabled="!hasSubmitOrdersPermission || isSizeQuantityZero(productSize)"
          >
          <div
            v-if="!isOrderButton && !onlyQuantityInput"
            :id="`${index}-${orderItemProduct.id}-decrease`"
            class="input-group-prepend"
            style="display: none"
          >
            <button
              class="btn btn-outline-secondary decrease-btn"
              type="button"
              @click="decrementQuantity(productSize)"
            >
              -
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="!onlyQuantityInput || !isDigitalCatalog"
        class="col-2"
      >
        <order-button
          v-if="isOrderButton"
          :is-in-order="orderItemProduct.active_order"
          class="order-btn-size-quantity"
          :data="orderItemProduct"
          :is-order-button-disable="isOrderButtonDisable"
          @orderClick="onOrderClick"
          :disabled="!hasSubmitOrdersPermission || !canOrderProduct(orderItemProduct)"
        />
        <popper
          v-else
          :ref="`duplicateQuantitiesIcon-${orderIndex}-${productIndex}`"
          trigger="clickToToggle"
          :options="{
            placement: 'right',
          }"
        >
          <div class="popper">
            <div class="popper-copy-to">
              <div class="copy-to-item-text">
                Copy To:
              </div>
              <hr>
              <div
                class="copy-to-item mbottom cursor-pointer"
                @click="
                  copyQuantity(
                    orderItemProduct,
                    orderIndex + '-' + productIndex,
                    'ALL'
                  )
                "
              >
                All
              </div>
              <div
                class="copy-to-item mbottom cursor-pointer"
                @click="
                  copyQuantity(
                    orderItemProduct,
                    orderIndex + '-' + productIndex,
                    'SELECTED'
                  )
                "
              >
                Selected
              </div>
              <div
                class="copy-to-item mbottom cursor-pointer"
                @click="
                  copyQuantity(
                    orderItemProduct,
                    orderIndex + '-' + productIndex,
                    'CATEGORY'
                  )
                "
              >
                Category
              </div>
              <div
                class="copy-to-item mbottom cursor-pointer"
                @click="
                  copyQuantity(
                    orderItemProduct,
                    orderIndex + '-' + productIndex,
                    'BRAND/CATEGORY'
                  )
                "
              >
                Brand/Category
              </div>
              <div
                class="copy-to-item cursor-pointer"
                @click="
                  copyQuantity(
                    orderItemProduct,
                    orderIndex + '-' + productIndex,
                    'DEPARTMENT'
                  )
                "
              >
                Department
              </div>
            </div>
          </div>
          <div slot="reference">
            <button
              type="button"
              class="btn bg-dark text-white border-0 rounded-circle p-0"
            >
              <fa
                icon="copy"
                fixed-width
              />
            </button>
          </div>
        </popper>
      </div>
    </div>
    <div
      v-for="(
        productDateQuantity, productDateQuantityIndex
      ) in orderItemProduct.product_date_quantities"
      :key="productDateQuantityIndex"
      class="row align-items-center"
    >
      <div class="col-2 text-end">
        <label v-if="productDateQuantityIndex !== 0">
          {{
            formatDate(
              productDateQuantity.purchased_order_available_at
            )
          }}
        </label>
        <label v-else> Immed </label>
      </div>
      <div class="size-group col-8">
        <p
          v-for="(
            quantity, index
          ) of productDateQuantity.quantities.split(',')"
          :key="index"
          :class="{ 'text-danger': quantity === '0' }"
        >
          {{ quantity }}
        </p>
      </div>
    </div>
    <!-- Prebook Date Row -->
    <div
      v-if="orderItemProduct.is_prebooked && orderItemProduct.prebook_date"
      class="row align-items-center prebook-date-row"
    >
      <div class="col-2 text-end">
      </div>
      <div class="col-8">
        <span class="prebook-date-label">Prebook: Start Ship {{ orderItemProduct.prebook_date_formatted }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import OrderButton from '../components/common/CatalogProductList/ProductActionButtons//OrderButton.vue'
import { mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { PERMISSIONS } from '~/constants'
import moqValidation from '~/mixins/moqValidation'
import productOrderable from '~/mixins/productOrderable'

export default {
  name: 'QuantityInput',
  mixins: [moqValidation, productOrderable],
  components: { OrderButton },
  props: {
    orderItemProduct: {
      type: Object,
      default: () => ({})
    },
    productIndex: {
      type: Number,
      default: 0
    },
    orderIndex: {
      type: Number,
      default: 0
    },
    isOrderButton: {
      type: Boolean,
      default: false
    },
    onlyQuantityInput: {
      type: Boolean,
      default: false
    },
    isDigitalCatalog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    productOrder: {},
    handleClickOutside: null
  }),
  computed: {
    ...mapGetters({
      catalogProducts: 'catalog_products/catalogProducts',
      activeDraftOrder: 'orders/activeDraftOrder',
      newOrderProduct: 'orders/newOrderProduct',
      isAssociate: 'auth/isAssociate',
      permissions: 'auth/permissions'
    }),
    isOrderButtonDisable () {
      return !(
        (this.productOrder &&
                    this.productOrder.products &&
                    this.productOrder.products.length) ||
                (this.newOrderProduct &&
                    this.newOrderProduct.products &&
                    this.newOrderProduct.products.length &&
                    !this.activeDraftOrder)
      )
    },
    hasSubmitOrdersPermission () {
        return this.permissions?.includes(PERMISSIONS.SUBMIT_ORDERS)
    },
  },
  watch: {
    activeDraftOrder (newVal, oldVal) {
      if (newVal !== oldVal) {
        //this.productOrder = {}
      }
    }
  },
  mounted () {
    this.handleClickOutside = (event) => {
      // Check if the click was outside the product-item-sizes components
      const isClickInsideAny = Array.from(document.querySelectorAll('.quantity-input')).some(el =>
        el.contains(event.target)
      )

      if (!isClickInsideAny) {
        // Hide all elements with specified classes
        ['input-group-prepend', 'input-group-append'].forEach(
          (className) => {
            this.hideAll(className)
          }
        )
      }
    }

    // Add event listener for clicks outside the component
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    // Remove event listener when the component is destroyed
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapActions({
      toggleCatalogProductsProperty:
                'catalog_products/toggleCatalogProductsProperty',
      isOrderHasProductQuantities: "orders/isOrderHasProductQuantities"
    }),
    /**
     * Check if prebook bypass is enabled for this product
     * Bypass applies when: is_prebooked=1 AND prebook_date exists AND start_ship_date > prebook_date
     */
    isPrebookBypassEnabled () {
      // Check if product is prebooked and has prebook_date
      if (!this.orderItemProduct?.is_prebooked || !this.orderItemProduct?.prebook_date) {
        return false
      }

      // Get order's start ship date (raw format: Y-m-d)
      const startShipDateRaw = this.activeDraftOrder?.start_ship_date_raw
      if (!startShipDateRaw) {
        return false
      }

      // Compare dates as strings (both in Y-m-d format) - bypass if start_ship_date >= prebook_date
      // String comparison works correctly for Y-m-d format and avoids timezone issues
      return startShipDateRaw >= this.orderItemProduct.prebook_date
    },
    productQuantityValidate (productSize) {
      if (productSize.user_given_quantity === 0) {
        productSize.user_given_quantity = ''
      }

      // Bypass validation for prebooked products with start_ship_date > prebook_date
      if (this.isPrebookBypassEnabled()) {
        return ''
      }

      return productSize.user_given_quantity > productSize.quantity_available ? { 'background-color': '#FF8B8B' } : ''
    },
    hideAll (type) {
      const elements = document.querySelectorAll(`.${type}`)
      elements.forEach((element) => {
        element.style.display = 'none'
      })
    },
    highlight (id) {
      if (this.isOrderButton) return

      // Select input elements and attach the click event listener
      document.querySelectorAll(`[id^="${id}"]`).forEach((element) => {
            if (element.tagName === 'INPUT') {
                element.addEventListener('click', () => {
                    element.select();
                });
            }
      });

        // Hide all elements with specified classes
      ['input-group-prepend', 'input-group-append'].forEach((className) => {
          this.hideAll(className);
      });

        // Display increase and decrease buttons
      ['increase', 'decrease'].forEach((action) => {
        document.querySelectorAll(`[id^="${id}-${action}"]`).forEach((element) => {
            element.style.display = 'block';
        });
      });
    },
    incrementQuantity (productSize) {
      productSize.user_given_quantity = this.nextMoqValue(productSize, productSize.user_given_quantity)
      this.inputSize(
        this.orderItemProduct,
        productSize,
        productSize.user_given_quantity.toString()
      )
    },
    decrementQuantity (productSize) {
      const current = Number(productSize.user_given_quantity) || 0
      if (current > 0) {
        productSize.user_given_quantity = this.prevMoqValue(productSize, current)
        this.inputSize(
          this.orderItemProduct,
          productSize,
          productSize.user_given_quantity.toString()
        )
      }
    },
    /**
     * Commit the typed quantity (blur / Enter). Snaps a non-multiple up to the
     * nearest pack (with popup) and persists the corrected value. A value that is
     * already a valid multiple was persisted by the debounced input, so this is a
     * no-op for it — avoids a redundant write and a spurious dialog.
     */
    commitMoqQuantity (orderItemProduct, productSize) {
      if (!this.moqEnforcedForSize(productSize)) {
        return
      }
      const before = Number(productSize.user_given_quantity) || 0
      const after = this.applyMoqSnap(productSize)
      if (after !== before) {
        if (this.inputSizeQuantity && this.inputSizeQuantity.cancel) {
          this.inputSizeQuantity.cancel()
        }
        this.inputSize(orderItemProduct, productSize, after)
      }
    },
    handleInputQuantity(event, orderItemProduct, productSize) {
      // Get value and ensure it's positive
      let value = Math.abs(event.target.value);

      // Restrict to 7 digits
      if (value.toString().length > 7) {
          value = parseInt(value.toString().substring(0, 7), 10);
          event.target.value = value;
      }

      // Update model
      productSize.user_given_quantity = value;

      // Use the existing debounced function
      this.inputSizeQuantity(orderItemProduct, productSize, value);
    },
    inputSizeQuantity: debounce(async function (
      orderItemProduct,
      productSize,
      orderedQuantity = null
    ) {
      if (orderItemProduct.active_order && this.onlyQuantityInput) {
        await this.$emit('orderClick', false)
      }

      if (orderItemProduct.active_order && this.isOrderButton) {
         await this.onOrderClick(false)
      }

      setTimeout(() => {
         this.inputSize(orderItemProduct, productSize, orderedQuantity)
      }, 100)
    },
    300),
    inputSize (orderItemProduct, productSize, orderedQuantity = null) {
      this.isOrderHasProductQuantities(false)

      // MOQ: while the value is a non-multiple (user mid-typing), defer everything —
      // the snap + persist happen on commit (blur / Enter, see commitMoqQuantity).
      // A valid multiple persists normally.
      if (this.isMoqPartial(productSize)) {
        return
      }

      orderedQuantity = parseInt(orderedQuantity)
      if (this.onlyQuantityInput) {
        this.$emit(
          'onOrderProductItemSizeInput',
          orderedQuantity,
          productSize
        )
        return
      }

      if (this.isOrderButton) {

        const sizeId = productSize.id
        if (orderedQuantity === 0) {
          return
        }

        // this.activeDraftOrder will be undefined when you first time creating
        // an order and adding a product in it
        if (this.activeDraftOrder === undefined) {
          if (Object.keys(this.productOrder).length === 0) {
            this.productOrder = {
              products: [
                {
                  product_id: orderItemProduct.id,
                  size_id: sizeId,
                  quantity: orderedQuantity
                }
              ]
            }
          } else {
            this.productOrder.products.push({
              product_id: orderItemProduct.id,
              size_id: sizeId,
              quantity: orderedQuantity
            })
          }
          return
        }

        if (Object.keys(this.productOrder).length === 0) {
          this.productOrder = {
            order_id: this.activeDraftOrder?.id,
            products: [
              {
                product_id: orderItemProduct.id,
                size_id: sizeId,
                quantity: orderedQuantity
              }
            ]
          }

        } else {
          if (
            !this.productOrder.hasOwnProperty('order_id') ||
                        this.productOrder.order_id !== this.activeDraftOrder?.id
          ) {
            this.productOrder.order_id = this.activeDraftOrder?.id
          }

          this.productOrder.products.push({
            product_id: orderItemProduct.id,
            size_id: sizeId,
            quantity: orderedQuantity
          })
        }
      } else {
        this.$emit(
          'onOrderProductItemSizeInput',
          orderItemProduct,
          productSize
        )
      }
    },

    formatDate (dateString) {
      const options = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      }
      return new Date(dateString).toLocaleDateString('en-US', options)
    },

    copyQuantity (orderItemProduct, index, type) {
      this.$emit('handleCopy', orderItemProduct, type)
      this.closePopper(index)
      this.isOrderHasProductQuantities(false)
    },

    closePopper (index) {
      const refName = `duplicateQuantitiesIcon-${index}`
      this.$refs[refName].doClose()
    },

    async onOrderClick () {
       if (Object.keys(this.productOrder).length === 0 && !this.orderItemProduct.active_order)  {
           this.productOrder = {
               order_id: this.activeDraftOrder?.id,
               product_ids: [this.orderItemProduct.id]
           }
       }

      this.$emit(
        'toggleProductButton',
        '',
        1,
        'active_order',
        this.orderItemProduct,
        this.productOrder,
        true
      )

      this.productOrder = {}
    },
    onlyNumberKey(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      const currentValue = evt.target.value;

      // Allow backspace (8), delete (46), and numbers (48-57)
      if (charCode !== 8 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
      }

      // Prevent typing if the current value already has 7 digits
      if (currentValue.length >= 7 && charCode !== 8 && charCode !== 46) {
          evt.preventDefault();
      }
    },
    isSizeQuantityZero(productSize) {
      // A prebooked line stays orderable no matter what the current buckets say — the
      // backend agrees (ProductRepository::isProductOrderable) and checkout turns the
      // shortfall into a backorder.
      if (this.orderItemProduct?.is_prebooked && this.orderItemProduct?.prebook_date) {
        return false
      }

          // Get the index of the current size in product_sizes array
          const sizeIndex = this.orderItemProduct.product_sizes.findIndex(
              size => size.id === productSize.id
          );

          if (sizeIndex === -1) return false;

          // Check if all quantities for this size index are zero across all date entries
          return this.orderItemProduct.product_date_quantities.every(dateQuantity => {
              const quantities = dateQuantity.quantities.split(',');
              // If we have a value at the size index and it's not "0", return false
              return !quantities[sizeIndex] || quantities[sizeIndex] === '0';
          });
      }
  }
}
</script>

<style lang="scss" scoped>
.product-item {
    display: grid;
    grid-template-columns: 200px auto 50px;
    align-items: center;
    width: 100%;
    border: 1px solid #e3e2e2;
    margin-top: 5px;
    input {
        width: 60px;
    }
    &-sizes {
        width: 400px;
        .row {
            line-height: 1;
        }
        label {
            font: normal normal normal 13px/23px Arial;
            letter-spacing: 0px;
            color: #383838;
            line-height: 1.5;
        }
        p {
            margin-bottom: 0px;
            text-align: center;
            font: normal normal normal 13px/23px Arial;
            letter-spacing: 0px;
            color: #383838;
            line-height: 1.5;
        }
        span {
            font: normal normal normal 15px/23px Arial;
            letter-spacing: 0px;
            color: #383838;
            text-align: center;
        }
        .size-group {
            display: grid;
            grid-template-columns: repeat(6, 50px);
            input {
                width: 50px;
                height: 40px;
                border: 5px solid #e8e7e7;
                text-align: center;
                font: normal normal bold 13px/15px Arial;
                letter-spacing: 0px;
                color: #383838;
                padding-right: 10px;
                padding-left: 10px;
                &[type="number"] {
                    -moz-appearance: textfield;
                }

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                }
            }
            .text-danger {
                font: normal normal bold 15px/23px Arial;
                line-height: 1.2;
            }
        }
        button {
            width: 31px;
            height: 31px;
        }
        .popper {
            .popper-copy-to {
                padding: 10px;

                .copy-to-item-text {
                    text-align: left;
                    font: normal normal normal 13px/15px Arial;
                    letter-spacing: 0px;
                    color: #383838;
                }

                hr {
                    margin: 10px 0;
                }

                .copy-to-item {
                    text-align: left;
                    font: normal normal normal 13px/15px Arial;
                    letter-spacing: 0px;
                    color: #383838;

                    &.mbottom {
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
}

button {
    font: normal normal bold 13px/15px Arial;
    letter-spacing: 0px;
}
.input-group {
    justify-content: center;
    gap: 1px;
    button,
    button:active {
        background-color: #e3e2e2;
        border: none;
        border-radius: 0;
        color: #000000;
    }
    .input-group-append {
        position: absolute;
        bottom: 41px;
    }
    .input-group-prepend {
        top: 41px;
        position: absolute;
    }
}

.prebook-date-row {
    margin-top: 8px;
    .prebook-date-label {
        display: inline-block;
        background: rgba(255, 0, 0, 0.05);
        padding: 4px 12px;
        font: normal normal normal 13px/15px Arial;
        letter-spacing: 0px;
        color: #383838;
    }
}
</style>
